import React, { FC, useCallback, useState } from 'react';
import BidPickerOverlay from './BidPickerOverlay';
import { Dropdown } from 'src/common';
import styles from './index.module.scss';
import { ISelectedCallOff } from 'src/models/callOffs/types';
import { WorkspaceBadgeMode } from '../../common/WorkspaceBadge';
import BidPickerShortModeAction from './BidPickerShortModeAction';
import BidPickerFullModeAction from './BidPickerFullModeAction';
import { IBidIdentifier } from 'src/models/bids/Bids/types';
import useLinkedBidsSearchArgs from 'src/reactiveVars/SelectedBidsSearchArgsVar';

interface IProps {
  selectedCallOffs: ISelectedCallOff[];
  placeHolderBid?: IBidIdentifier;

  eventSource: string;
  mode?: WorkspaceBadgeMode;
  showTooltip?: boolean;
  onChange?: () => void;
}

const BidPicker: FC<IProps> = props => {
  const { mode, showTooltip, selectedCallOffs, placeHolderBid, onChange, eventSource } = props;

  const [menuVisible, setMenuVisible] = useState(false);
  const [isUpdating, setIsUpdating] = useState(false);
  const [, resetSearch] = useLinkedBidsSearchArgs();
  const onClose = useCallback(() => {
    setMenuVisible(false);
    resetSearch(undefined);
  }, [resetSearch]);

  const onVisibleChange = useCallback(() => {
    setMenuVisible(!menuVisible);
  }, [menuVisible]);

  return (
    <Dropdown
      trigger={['click']}
      visible={menuVisible}
      onVisibleChange={onVisibleChange}
      overlayClassName={styles.pickerMenu}
      placement={'bottomRight'}
      overlay={
        <BidPickerOverlay
          onCloseDropDown={onClose}
          selectedCallOffs={selectedCallOffs}
          setIsUpdating={setIsUpdating}
          onChange={onChange}
          eventSource={eventSource}
        />
      }
    >
      <div className={styles.button}>
        {mode === 'short' && (
          <BidPickerShortModeAction
            bid={placeHolderBid}
            onVisibleChange={onVisibleChange}
            showTooltip={showTooltip}
            isUpdating={isUpdating}
            isActive={menuVisible}
          />
        )}
        {mode === 'full' && (
          <BidPickerFullModeAction bid={placeHolderBid} onVisibleChange={onVisibleChange} isUpdating={isUpdating} />
        )}
      </div>
    </Dropdown>
  );
};

export default BidPicker;
